import HttpClient from './http';

export const readMessagesRequest = (params: Record<string, any>): Promise<any> => {
  return HttpClient.patch({ path: 'api/subscribtion', baseURL: process.env.REACT_APP_MESSAGES_URL as string }, params);
};
